/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ResponseUserWeeklyScheduleDto } from '../models/response-user-weekly-schedule-dto';
import { userWeeklyScheduleControllerCreate } from '../fn/user-weekly-schedule/user-weekly-schedule-controller-create';
import { UserWeeklyScheduleControllerCreate$Params } from '../fn/user-weekly-schedule/user-weekly-schedule-controller-create';
import { userWeeklyScheduleControllerDelete } from '../fn/user-weekly-schedule/user-weekly-schedule-controller-delete';
import { UserWeeklyScheduleControllerDelete$Params } from '../fn/user-weekly-schedule/user-weekly-schedule-controller-delete';
import { userWeeklyScheduleControllerFindOne } from '../fn/user-weekly-schedule/user-weekly-schedule-controller-find-one';
import { UserWeeklyScheduleControllerFindOne$Params } from '../fn/user-weekly-schedule/user-weekly-schedule-controller-find-one';
import { userWeeklyScheduleControllerUpdate } from '../fn/user-weekly-schedule/user-weekly-schedule-controller-update';
import { UserWeeklyScheduleControllerUpdate$Params } from '../fn/user-weekly-schedule/user-weekly-schedule-controller-update';

@Injectable({ providedIn: 'root' })
export class UserWeeklyScheduleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userWeeklyScheduleControllerCreate()` */
  static readonly UserWeeklyScheduleControllerCreatePath = '/thalea-google-events/user-weekly-schedule';

  /**
   * Create user weekly schedule.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userWeeklyScheduleControllerCreate$Response(params: UserWeeklyScheduleControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleDto>> {
    return userWeeklyScheduleControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create user weekly schedule.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userWeeklyScheduleControllerCreate(params: UserWeeklyScheduleControllerCreate$Params, context?: HttpContext): Observable<ResponseUserWeeklyScheduleDto> {
    return this.userWeeklyScheduleControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseUserWeeklyScheduleDto>): ResponseUserWeeklyScheduleDto => r.body)
    );
  }

  /** Path part for operation `userWeeklyScheduleControllerFindOne()` */
  static readonly UserWeeklyScheduleControllerFindOnePath = '/thalea-google-events/user-weekly-schedule/{tenant}/{email}';

  /**
   * Get user weekly schedule by tenant and email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleControllerFindOne$Response(params: UserWeeklyScheduleControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleDto>> {
    return userWeeklyScheduleControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user weekly schedule by tenant and email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleControllerFindOne(params: UserWeeklyScheduleControllerFindOne$Params, context?: HttpContext): Observable<ResponseUserWeeklyScheduleDto> {
    return this.userWeeklyScheduleControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseUserWeeklyScheduleDto>): ResponseUserWeeklyScheduleDto => r.body)
    );
  }

  /** Path part for operation `userWeeklyScheduleControllerDelete()` */
  static readonly UserWeeklyScheduleControllerDeletePath = '/thalea-google-events/user-weekly-schedule/{tenant}/{email}';

  /**
   * Delete user weekly schedule.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleControllerDelete$Response(params: UserWeeklyScheduleControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userWeeklyScheduleControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete user weekly schedule.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userWeeklyScheduleControllerDelete(params: UserWeeklyScheduleControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.userWeeklyScheduleControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userWeeklyScheduleControllerUpdate()` */
  static readonly UserWeeklyScheduleControllerUpdatePath = '/thalea-google-events/user-weekly-schedule/{tenant}/{email}';

  /**
   * Update user weekly schedule.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userWeeklyScheduleControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userWeeklyScheduleControllerUpdate$Response(params: UserWeeklyScheduleControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleDto>> {
    return userWeeklyScheduleControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update user weekly schedule.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userWeeklyScheduleControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userWeeklyScheduleControllerUpdate(params: UserWeeklyScheduleControllerUpdate$Params, context?: HttpContext): Observable<ResponseUserWeeklyScheduleDto> {
    return this.userWeeklyScheduleControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseUserWeeklyScheduleDto>): ResponseUserWeeklyScheduleDto => r.body)
    );
  }

}
